import { useEffect, useRef } from "react";
import { $getRoot, type RootNode, type LexicalNode } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $generateNodesFromDOM } from "@lexical/html";

interface HtmlHydrationPluginProps {
  html: string;
}

/**
 * Populates the editor with an HTML string on initial mount.
 */
export const HtmlHydrationPlugin = (props: HtmlHydrationPluginProps): null => {
  const [editor] = useLexicalComposerContext();
  const hasHydrated = useRef<boolean>(false);

  useEffect((): void => {
    if (hasHydrated.current) {
      return;
    }
    hasHydrated.current = true;
    if (!props.html) {
      return;
    }

    editor.update((): void => {
      const parser: DOMParser = new DOMParser();
      const dom: Document = parser.parseFromString(props.html, "text/html");
      const nodes: Array<LexicalNode> = $generateNodesFromDOM(editor, dom);
      const root: RootNode = $getRoot();
      root.clear();
      root.append(...nodes);
    });
  }, [editor, props.html]);

  return null;
};
